import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { ProductRemovedFromCartEventSchema } from '../../schemas/product/ProductRemovedFromCartEventSchema'
import { CommonEventParams } from '../../utils/CommonParams'

export interface ProductRemovedFromCartEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  FULFILMENT_CHANNEL: string
  CHECKOUT_FLOW: string
  PRODUCTS: any
}

export class ProductRemovedFromCartEvent extends AnalyticsEvent {
  constructor(params: ProductRemovedFromCartEventParams) {
    super(ProductRemovedFromCartEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export function trackProductRemovedFromCartEvent(
  params: ProductRemovedFromCartEventParams
) {
  const { isEnabled = false } =
    getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_FIVE) || {}
  if (isEnabled) {
    new ProductRemovedFromCartEvent(params).track()
  }
}
